import { some } from 'lodash'

export const hasConfiguredIntegration = (integrations) =>
  integrations?.length &&
  some(
    integrations,
    (integration) => integration?.syncStatus === 'complete' && integration?.status === 'alive'
  )
